// extracted by mini-css-extract-plugin
export var cardHeader = "_s9-0";
export var reorderHandle = "_s9-3";
export var titleArea = "_s9-1";
export var titleAreaWithHandle = "_s9-2";